<template>
<div class="formGroup" :data-layout="layout">
  <div class="formGroup__body">
    <formLabel :label="label" :validation="validation" :required="isRequired"></formLabel>
    <select
      ref="select"
      class="formControl"
      :class="{'error': errors.has(name)}"
      :name="name"
      :value="value"
      @change="update($event)"
      v-validate="validation"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :disabled="disabledControl(option)"
        :selected="selected === option.value"
      >{{ option.text }}</option>
    </select>
  </div>
  <div v-show="errors.first(name)" class="formGroup__footer">
    <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    <slot></slot>
  </div>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-select',
  mixins: [mixin],
  data: () => ({
    selected: ''
  }),
  props: {
    options: { type: Array, required: true },
    isdisabled: Boolean,
    defaultNoSelect: { type: Boolean, default: false },
    isRequired: {type: Boolean, default: false}
  },
  created() {
    this.selected = !this.value && !this.defaultNoSelect ? this.options[0].value : this.value
  },
  watch: {
    value() {
      if (!this.value) {
        this.selected = this.options[0]
      } else {
        this.selected = this.value
      }
    }
  },
  methods: {
    update($event) {
      let value = $event.target.selectedOptions.length ? $event.target.selectedOptions[0]._value : null
      this.$emit('input', value)
      this.$emit('selected', value)
      this.selected = value
    },
    disabledControl(option) {
      if (!!option.disabled && this.isdisabled === true) return true
      return false
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormSelect.vue